import { Link } from '../lib/routerCompat';

export default function PrivacyView(): JSX.Element {
  return (
    <div className="legal-page">
      <Link to="/" className="legal-back">
        ← Back to PitchVault
      </Link>
      <h1>Privacy Policy</h1>
      <p className="legal-updated">Last updated: July 24, 2026</p>

      <p>
        PitchVault (&ldquo;we&rdquo;, &ldquo;us&rdquo;) respects your privacy. This policy explains
        what we collect, why we collect it, and how we handle it.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Waitlist signups:</strong> your email address, whether you identify as a creator
          or a brand, and the page you signed up from.
        </li>
        <li>
          <strong>Account data (when accounts launch):</strong> profile information you provide,
          such as your name, role, and campaign or portfolio details.
        </li>
      </ul>

      <h2>How we use it</h2>
      <ul>
        <li>To notify you about PitchVault access, launches, and product updates.</li>
        <li>To operate the marketplace: matching brands with creators and facilitating deals.</li>
        <li>We do not sell your personal information to third parties.</li>
      </ul>

      <h2>Where it lives</h2>
      <p>
        Data is stored with our infrastructure providers (including Supabase and Amazon Web
        Services) in the United States, protected by industry-standard security controls.
      </p>

      <h2>Your choices</h2>
      <p>
        You can request removal from the waitlist or deletion of your data at any time by contacting
        us. Marketing emails will always include an unsubscribe option.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy? Reach us via{' '}
        <a href="https://www.gigadude.com" target="_blank" rel="noopener noreferrer">
          gigadude
        </a>
        .
      </p>
    </div>
  );
}
